// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-container {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    gap: 10px;
    /* margin: 20px; */
  }
  
  .dropdown-label {
    color: white;
    /* margin-bottom: 10px; */
    font-size: 14px;
  }
  
  .dropdown-select {
    padding: 2.5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px;
    outline: none;
    cursor: pointer;
    background-color: #007bff;
    color: white;
    max-width: 150px;
  }
  
  .dropdown-select option {
    background-color: #fff;
    color: #333;
  }
  
  .dropdown-select:focus {
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  
  .delete{
    font-size: 24px;
    color: white;
    cursor: pointer;
  }

  .close-popup {
    position: absolute;
    left: 60px;
    display: flex;
    max-width: 240px;
    min-height: 90px;
    background-color: white;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }

  .btns{
    display: flex;
    gap: 10px;
  }
  .y-n{
    border: 1px solid gray;
    border-radius: 20px;
    padding: 3px 10px;
  }
  .red {
    background-color: red;
    color: white;
  }
  .green{
    background-color: green;
    color: white;
  }`, "",{"version":3,"sources":["webpack://./src/components/css/DropdownComponent.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,YAAY;EACd","sourcesContent":[".dropdown-container {\n    display: flex;\n    /* flex-direction: column; */\n    align-items: center;\n    gap: 10px;\n    /* margin: 20px; */\n  }\n  \n  .dropdown-label {\n    color: white;\n    /* margin-bottom: 10px; */\n    font-size: 14px;\n  }\n  \n  .dropdown-select {\n    padding: 2.5px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    font-size: 14px;\n    outline: none;\n    cursor: pointer;\n    background-color: #007bff;\n    color: white;\n    max-width: 150px;\n  }\n  \n  .dropdown-select option {\n    background-color: #fff;\n    color: #333;\n  }\n  \n  .dropdown-select:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n  }\n  \n  .delete{\n    font-size: 24px;\n    color: white;\n    cursor: pointer;\n  }\n\n  .close-popup {\n    position: absolute;\n    left: 60px;\n    display: flex;\n    max-width: 240px;\n    min-height: 90px;\n    background-color: white;\n    border-radius: 10px;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n  }\n\n  .btns{\n    display: flex;\n    gap: 10px;\n  }\n  .y-n{\n    border: 1px solid gray;\n    border-radius: 20px;\n    padding: 3px 10px;\n  }\n  .red {\n    background-color: red;\n    color: white;\n  }\n  .green{\n    background-color: green;\n    color: white;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
